import api from './api'

export const workStagesAPI = {
  getAll: () => api.get('/work_stages.json'),
  get: (id) => api.get(`/work_stages/${id}.json`),
  create: (data) => api.post('/work_stages.json', { work_stage: data }),
  update: (id, data) => api.patch(`/work_stages/${id}.json`, { work_stage: data }),
  delete: (id) => api.delete(`/work_stages/${id}.json`),
  reorder: (ids) => api.patch('/work_stages/reorder.json', { ids }),

  // Works within a work stage
  getWorks: (workStageId) => api.get(`/work_stages/${workStageId}/works.json`),
  createWork: (workStageId, data) => api.post(`/work_stages/${workStageId}/works.json`, { work: data }),
  updateWork: (workStageId, workId, data) => api.patch(`/work_stages/${workStageId}/works/${workId}.json`, { work: data }),
  deleteWork: (workStageId, workId) => api.delete(`/work_stages/${workStageId}/works/${workId}.json`),
  reorderWorks: (workStageId, ids) => api.patch(`/work_stages/${workStageId}/works/reorder.json`, { ids }),
}
